define('specific/customloader/views/CustomLoaderView', [
    'specific/customloader/templates/customloader'
], function(tpl) {

    var CustomLoaderView = Mazarine.View.extend({

        events: {
        },

        template: tpl,

        className: "maz-customloader-view",

        initialize: function() {
            Mazarine.View.prototype.initialize.call(this);
            this.listenTo( this.model, 'change:percent', this.onPercentChange );
        },

        onPercentChange: function( model, percent ) {
            this.$('.maz-percentage-block').html( percent + "%" );
        }
    });

    return CustomLoaderView;
});
